module.exports = __webpack_public_path__ + "static/media/15a-02_ST-2015-405x295mm-oleo-sobre-papel.033333f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15a/15a-02_ST-2015-405x295mm-oleo-sobre-papel.jpg
// module id = 155
// module chunks = 0